import { ABOUT_US, BASE_URL } from "constants/api";
import axios from "../helpers/axiosInstance";
import { HeadCell } from "models/app";
import { ApiResponse } from "./auth";
import { IAboutUS, IAboutUSInput } from "models/aboutus";


export async function getAboutUs(params: string = "") : Promise<ApiResponse<IAboutUS[]>> {
  const response = await axios.get(BASE_URL + ABOUT_US + params);
  return response.data;
}

export async function editAboutUS(data: IAboutUSInput, id: string) {
  const response = await axios.put(BASE_URL + ABOUT_US + `\\${id}` , {...data,id:+id});
  return response.data;
}


export const AboutUSCells: HeadCell[] = [
  {
    id: "title",
    numeric: false,
    disablePadding: false,
    label: "Title",
    
  },
  {
    id: "content",
    numeric: false,
    disablePadding: false,
    label: "Content",
  },
  {
    id: "actions",
    numeric: false,
    disablePadding: false,
    label: "Actions",
  },
];